import { Button, Modal, Typography } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import usePatientSync from "../../hooks/usePatientSync";

const { Paragraph } = Typography;

const SEEN_KEY = "nudge.patientSyncNoticeSeen";

/** One-time, dismissible heads-up that the patient list is still being fetched. */
export default function PatientSyncModal() {
  const { isSyncing } = usePatientSync();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  // Only where the patient list lives, never over sign-up or the questionnaire.
  const onPatientList = pathname === "/" || pathname.startsWith("/home") || pathname.startsWith("/notesforMobile");
  useEffect(() => {
    if (!isSyncing || !onPatientList) return;
    try {
      if (localStorage.getItem(SEEN_KEY)) return;
    } catch {
      // Storage disabled: showing it again beats never showing it.
    }
    setOpen(true);
  }, [isSyncing, onPatientList]);

  const close = () => {
    setOpen(false);
    try {
      localStorage.setItem(SEEN_KEY, "1");
    } catch {
      // Reappears next session.
    }
  };

  return (
    <Modal
      open={open}
      onCancel={close}
      centered
      width={400}
      title="Setting up your patient list"
      footer={[
        <Button key="ok" type="primary" onClick={close}>
          Got it
        </Button>,
      ]}
    >
      <Paragraph style={{ marginBottom: 8 }}>
        We're pulling today's schedule from your EHR. This usually takes a few minutes, and your patients will appear
        automatically.
      </Paragraph>
      <Paragraph style={{ marginBottom: 0 }}>You can add a patient manually any time.</Paragraph>
    </Modal>
  );
}
